import { getRouters } from '@/api/router'
import Layout from '@/layout/index'
import i18n from '@/lang'
import { constantRoutes } from '@/router'

const permission = {
  state: {
    routes: [],
    addRoutes: [],
    sidebarRouters: [],
    indexPage: '',
    roleKey: '',
    viewCache: {}
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = routes
    },
    SET_ROLE_KEY: (state, roleKey) => {
      console.log('roleKey', roleKey)
      state.roleKey = roleKey
    },
    SET_SIDEBAR_ROUTERS: (state, routes) => {
      state.sidebarRouters = routes
    },
    SET_INDEX_PAGE: (state, indexPage) => {
      state.indexPage = indexPage
    },
    SET_VIEW_CACHE: (state, viewCache) => {
      state.viewCache = viewCache
    }
  },
  actions: {
    // 生成路由
    GenerateRoutes({ commit, rootState }) {
      const type = process.env.VUE_APP_PREFIX === 'tbbaccess' ? 2 : 1
      const userName = rootState.user.name
      const roleList = rootState.user.roles || []
      console.log('roleList', rootState.user.roles)
      // | `roleKey` | string | SUPER_ADMIN / L1_ADMIN / L1_SUPPORT / L2_ADMIN|
      return new Promise(async (resolve) => {
        let requestData = []
        let constantRoutesNew = JSON.parse(JSON.stringify(constantRoutes))
        if (roleList.find(item => item.roleKey === 'SUPER_ADMIN'||item.roleKey === 'L2_SUPPORT')) {
          requestData = constantRoutesNew
          commit('SET_ROLE_KEY', '0')
        }else if (roleList.find(item => item.roleKey === 'L1_ADMIN')) {
           requestData = constantRoutesNew.map(item => {
             if (item.children) {
               item.children = item.children.filter(child => child.path !== '/device/public-group/index'
               && child.path !== '/device/agent/index')
             }
             return item
           })
          commit('SET_INDEX_PAGE', "/users/account/index")
          commit('SET_ROLE_KEY', '1')
        }else if (roleList.find(item => item.roleKey === 'L1_SUPPORT')) {
           requestData = constantRoutesNew.filter(item => item.path !== '/users').map(item => {
             if (item.children) {
               item.children = item.children.filter(child => child.path !== '/device/public-group/index'
               && child.path !== '/device/agent/index'
               && child.path !== '/device/territory/index'
               )
             }
             return item
           })
          commit('SET_ROLE_KEY', '2')
        }else {
          commit('SET_ROLE_KEY', '999')
          requestData = constantRoutesNew.filter(item => item.path == '/setting/set')
        }

        
        console.log('requestData', requestData)
        commit('SET_ROUTES', requestData)
        commit('SET_SIDEBAR_ROUTERS', requestData)
        resolve(requestData)
       
        // if (requestData.length > 0) {
        //   const sdata = JSON.parse(JSON.stringify(requestData))
        //   const rdata = JSON.parse(JSON.stringify(requestData))
        //   const isChild =
        //     requestData[0].children && requestData[0].children.length > 0
        //   const indexPage = isChild
        //     ? requestData[0].path + '/' + requestData[0].children[0].path
        //     : requestData[0].path
        //   const sidebarRoutes = filterAsyncRouter(sdata)
        //   const rewriteRoutes = filterAsyncRouter(rdata, false, true)
        //   rewriteRoutes.push({ path: '*', redirect: '/404', hidden: true })
         
          
        //   commit('SET_INDEX_PAGE', indexPage)
        //   resolve(rewriteRoutes)
        // } else {
        //   resolve([])
        // }
      })
    },
    setViewCache({ commit }, viewCache) {
      console.log('viewCache', viewCache)
      commit('SET_VIEW_CACHE', viewCache)
    }
  }
}

function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
  return asyncRouterMap.filter((route) => {
    if (type && route.children) {
      route.children = filterChildren(route.children)
    }
    if (route.component) {
      if (typeof route.component === 'string') {
        if (route.component === 'Layout') {
          route.component = Layout
        } else {
          route.component = loadView(route.component, route)
        }
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type)
    } else {
      delete route['children']
      delete route['redirect']
    }
    return true
  })
}

function filterChildren(childrenMap, lastRouter = false) {
  var children = []
  childrenMap.forEach((el, index) => {
    if (lastRouter) {
      el.path = lastRouter.path + '/' + el.path
    }
    children = children.concat(el)
  })
  return children
}

// export const loadView = (view) => {
//   if (process.env.NODE_ENV === 'development') {
//     return (resolve) => require([`@/views/${view}`], resolve)
//   } else {
//     // 使用 import 实现生产环境的路由懒加载
//     return () => import(`@/views/${view}`)
//   }
// }

export const loadView = (view, route) => {
  const page = route?.page || 'pro'
  return (resolve) => {
    if (page === 'tbbaccess') {
      require([`@/tbbaccess/views/${view}`], resolve)
    } else {
      require([`@/views/${view}`], resolve)
    }
  }
}

export default permission
